import {
  Alert,
  AlertTitle,
  Backdrop,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAuth, signIn } from "../store/features/authSlice"

export const SignInScreen = () => {
  const dispatch = useDispatch()
  const auth = useSelector(getAuth)
  const [showPassword, setShowPassword] = useState(false)
  const [credentials, setCredentials] = useState({
    id: "",
    password: "",
    role: 1,
  })

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleChangeCredentials = (e) => {
    const name = e.target.name
    const value = e.target.value
    setCredentials({ ...credentials, [name]: value })
  }

  const handleSignIn = () => {
    console.log(credentials)
    dispatch(signIn(credentials))
  }

  return (
    <>
      {auth.status === "loading" && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={auth.status === "loading"}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
        maxWidth="sm"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h2" gutterBottom textAlign="center">
              CIP Móvil <span style={{ opacity: 0.5 }}>Console</span>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Id de usuario</InputLabel>
              <OutlinedInput
                type="text"
                label="Id de usuario"
                name="id"
                defaultValue={credentials.id}
                onChange={handleChangeCredentials}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Contraseña</InputLabel>
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Contraseña"
                name="password"
                defaultValue={credentials.password}
                onChange={handleChangeCredentials}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              sx={{ height: 55 }}
              onClick={handleSignIn}
            >
              Ingresar
            </Button>
          </Grid>
          {auth.status === "failed" && (
            <Grid item xs={12}>
              <Alert severity="warning">
                <AlertTitle>Advertencia</AlertTitle>
                Usuario o contraseña incorrecta —{" "}
                <strong>Intente nuevamente</strong>
              </Alert>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  )
}
